// ─── Accordéon (Core) ─────────────────────────────────────────────
// Standard app-wide : les pages de réglages sont faites de sections repliables,
// une seule ouverte à la fois si l'écran pilote `ouvert`.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function SectionPliable({ titre, emoji, sousTitre, ouvert, onToggle, action, children }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={s.bloc}>
      <TouchableOpacity style={s.tete} onPress={onToggle} activeOpacity={0.7}>
        {!!emoji && <Text style={s.emoji}>{emoji}</Text>}
        <View style={{ flex: 1 }}>
          <Text style={s.titre}>{titre}</Text>
          {!!sousTitre && <Text style={s.sous} numberOfLines={1}>{sousTitre}</Text>}
        </View>
        {/* Action propre à la section (ex. ➕), à gauche du chevron. */}
        {!!action && <View style={s.action}>{action}</View>}
        <Text style={s.chev}>{ouvert ? '▾' : '›'}</Text>
      </TouchableOpacity>
      {ouvert && <View style={s.corps}>{children}</View>}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  bloc:  { backgroundColor: UI.card, borderRadius: 13, borderWidth: 1, borderColor: UI.border,
           marginBottom: 10, overflow: 'hidden' },
  tete:  { flexDirection: 'row', alignItems: 'center', gap: 11, padding: 14 },
  emoji: { fontSize: 20 },
  titre: { fontSize: 15, fontWeight: '700', color: UI.ink },
  sous:  { fontSize: 12, color: UI.muted, marginTop: 1 },
  action:{ marginRight: 2 },
  chev:  { fontSize: 18, color: UI.faint, fontWeight: '300' },
  corps: { paddingHorizontal: 14, paddingBottom: 14, borderTopWidth: 0.5, borderTopColor: UI.border, paddingTop: 12 },
});
